module.exports = __webpack_public_path__ + "img/type3.e65eaf9d.png";